module.exports = __webpack_public_path__ + "static/media/home_desktop_bg.985fec65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_desktop_bg.png
// module id = 108
// module chunks = 0